// extracted by mini-css-extract-plugin
module.exports = {"terms":"style_terms__OlSvK","link":"style_link__zmFCt"};